import { render, staticRenderFns } from "./badmintonRuleDialog.vue?vue&type=template&id=ee8f956a&"
import script from "./badmintonRuleDialog.vue?vue&type=script&lang=js&"
export * from "./badmintonRuleDialog.vue?vue&type=script&lang=js&"
import style0 from "./badmintonRuleDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports